import { FileStackPicker } from '../legacy-js/custom-plugins/files/FileStackPicker';
import '../legacy-js/custom-plugins/files/picker-actions';

/**
 * @fileoverview Initializes and manages the Filestack file uploading process.
 * This class centralizes DOM access and passes necessary context to the
 * FileStackPicker wrapper before opening the picker.
 *
 * It is required to import:
 * - FileStackPicker: The local wrapper class for the Filestack SDK.
 * - picker-actions: Contains the callback functions (uploadComplete, fileSelected)
 * that handle the Filestack events using the context provided by this class.
 */
class InitFileStackUploader {
    constructor() {
        this.fileStack = new FileStackPicker({
            apiKey: window.app?.config?.filestackKey,
            workflowID: window.app?.config?.filestackWorkflowId,
            options: {}
        });

        this.$uploadContainer = $('#uploadContainer'); // assuming there really is only one id on the page

        // Set up event delegation on the document to capture clicks on dynamically
        // added elements ('.upload-later', '.upload-now', '.upload-file').
        this.addEventListeners();
    }

    addEventListeners() {
        
        $(document).on('click', '.upload-later', (e) => { this.handleUploadLater(e) });
        $(document).on('click', '.upload-now', (e) => { this.handleUploadNow(e) });
        $(document).on('click', '.upload-file', (e) => { this.handleUploadFile(e) });
    }

    // --- METHODS FOR HANDLING USER ACTIONS ---

    /**
     * Gathers the critical DOM elements (form, container, button) and passes them
     * to the FileStackPicker instance. This ensures the Filestack callback functions
     * (defined in 'picker-actions.js') have access to the elements they need for
     * form submission and input creation.
     *
     * @param {jQuery} $triggerButton The jQuery object of the button that initiated the file upload.
     * @returns {boolean} True if the context was successfully set, false otherwise.
     */
    setFileStackContext($triggerButton) {
        const $uploadForm = $triggerButton.closest('#uploadForm, #custom_form, #prePressTicketForm');

        if (!$uploadForm.length) {
            console.error("Form is missing, cannot set Filestack context.");
            return false;
        }

        // Pass the necessary context to FilestackPicker.js > picker-actions.js
        this.fileStack.setContext({
            uploadButton: $triggerButton,
            uploadForm: $uploadForm,
            uploadContainer: this.$uploadContainer,
        });

        return true;
    }

    /**
     * Handles the 'Upload Later' button click.
     * Disables file inputs, hides the upload container, and shows the 'custom_artwork' area.
     * @param {Event} e The click event.
     */
    handleUploadLater(e) {
        e.preventDefault();
        const $uploadLaterForm = $(e.target).closest('#custom_form, #uploadForm');

        if (!$uploadLaterForm.length) {
            console.error("Form associated with the 'Upload Later' button not found.");
            return;
        }

        if (this.$uploadContainer.length) {
            this.$uploadContainer.find('.customer-file-container').find('.file-group-input').prop('disabled', true);
            this.$uploadContainer.hide();
        }

        $uploadLaterForm.find('.uploaded-file-input').prop('disabled', true);
        $('#custom_artwork').show();
    }

    /**
     * Handles the 'Upload Now' button click.
     * Enables file inputs and ensures the upload container is visible for the user to upload.
     * @param {Event} e The click event.
     */
    handleUploadNow(e) {
        e.preventDefault();
        const $uploadNowForm = $(e.target).closest('#custom_form, #uploadForm');

        if (!$uploadNowForm.length) {
            console.error("Form associated with the 'Upload Now' button not found.");
            return;
        }
        
        if ($uploadNowForm.valid()) {
            

            $uploadNowForm.find('.uploaded-file-input').prop('disabled', false);
            $('#custom_artwork').hide();
            
            if (this.$uploadContainer.length) {
                this.$uploadContainer.find('.customer-file-container').find('.file-group-input').prop('disabled', false);
                this.$uploadContainer.find('.customer-file-container').show();
            }
        }
    }

    /**
     * Handles the 'Upload File' button click.
     * Stores the button reference, sets the DOM context for Filestack, and opens the picker.
     * @param {Event} e The click event.
     */
    handleUploadFile(e) {
        e.preventDefault();
        const $uploadButton = $(e.target);

        if (this.setFileStackContext($uploadButton)) {
            this.fileStack.openPicker();
        }
    }
}

// The Filestack instance is not created on page load because the form and its triggers are dynamically injected into the DOM.
let filestackUploaderInstance = null;
$(function () {
    $(document).on('click', '.upload-later, .upload-now, .upload-file', function (e) {
        const $target = $(e.target).closest('.upload-later, .upload-now, .upload-file');

        if (filestackUploaderInstance === null) {
            filestackUploaderInstance = new InitFileStackUploader();
            $target.trigger('click');
        }
    });

    // add FilestackPicker to the window object for inline scripts
    window.FileStackPicker = FileStackPicker;

    if (!$('#add-item-modal').length) {
        $(document).on('filestack:upload-success', '#custom_form, #uploadForm', function (e, uploadedFiles) {
            const $form = $(this);

            const $uploadButton = filestackUploaderInstance.$uploadContainer.find('.upload-file');

            if (uploadedFiles && uploadedFiles.length > 0) {
                $uploadButton.find('span').text('Submitting...');

                // Execute native form submission, which causes the page redirect.
                $form.get(0).submit();
            } else {
                $uploadButton.prop('disabled', false).find('span').text('Select High-Res File');
            }
        }); 
    } 
});

